// filepath: /Users/prashanth.chintapally/Desktop/Projects/PBS-Gatsby/src/data/categoriesData.js
import hrimage from '../../../../images/categories/hr.png';
import healthandsafety from '../../../../images/categories/hs.png';
import legal from '../../../../images/categories/legal.png';
import webinars from '../../../../images/categories/webinars.png';
import podcasts from '../../../../images/categories/podcasts.png';
import shorts from '../../../../images/categories/shorts.png';

const CategoriesData = [
	{
		title: 'HR',
		image: hrimage,
		link: '/elearning/hr-and-employment-law/',
	},
	{
		title: 'H & S',
		image: healthandsafety,
		link: '/elearning/health-and-safety/',
	},
	{
		title: 'Webinars',
		image: webinars,
		link: '/elearning/webinars',
	},
	{
		title: 'Legal',
		image: legal,
		link: '/elearning/legal',
	},
	{
		title: 'Shorts',
		image: shorts,
		link: '/elearning/glu-shorts/',
	},
	{
		title: 'Podcasts',
		image: podcasts,
		link: '/elearning/glu-talk/',
	},
];

export default CategoriesData;
